module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 625 349",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }